import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { studyEDCLupReportingServices } from "../../../APIServices/studyEDCLupReportingServices";

const UploadFileDataLibrary = ({ Show, Hide, Title, getEDCLupDataLibrary }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [format, setFormat] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [type, setType] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileLabel, setFileLabel] = useState("");
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const handleFormatChange = (format) => {
    setFormat(format);
    setUploadFile(null);
  };

  const cleanInputBox = () => {
    Hide();
    setFormat("");
    setUploadFile("");
    setName("");
    setLabel("");
    setFileName("");
    setFileLabel("");
    setType("");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const csvType = file.type === "text/csv";
    const excelType =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (
      (format === "csv" && csvType) ||
      (format === "excel" && excelType)
    )
      setUploadFile(file);
    else {
      setUploadFile(null);
      alert(`Please select a ${format.toUpperCase()} file.`);
    }
  };

  const uploadFileinEDCLupDataLibrary = async () => {
    if (uploadFile) {
      setButtonLoader(true)
      const formData = new FormData();
      formData.append("studyId", studyId);
      formData.append("file", uploadFile);
      formData.append("label", label);
      formData.append("name", name);
      formData.append("fileName", fileName);
      formData.append("fileLabel", fileLabel);
      formData.append("mode", StudyMode);
      formData.append("type", type);
      let result = await studyEDCLupReportingServices.uploadFileinEDCLupDataLibrary(
        formData
      );
      setButtonLoader(false)
      if (result?.statusCode === 200) {
        cleanInputBox();
        getEDCLupDataLibrary();
      }
    }
  };

  const [error, setError] = useState("");

  const validatetitle = (input) => {
    const titleRegex = /^[a-zA-Z0-9_]+$/;

    if (!titleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Select Library{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setType(e.target.value)}
              value={type}
              required
            >
              <option value="">Select Library</option>
              <option value="Analysis">Analysis</option>
              <option value="Standard">Standard</option>
              <option value="Raw">Raw</option>
              <option value="Temp">Temp</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Format{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleFormatChange(e.target.value)}
              value={format}
              required
            >
              <option value="">Select Format</option>
              <option value="csv">CSV</option>
              <option value="excel">Excel</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Upload {format.toUpperCase()} File {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="file"
              disabled={!format}
              onChange={handleFileChange}
              accept={format === "csv" ? ".csv" : ".xls, .xlsx"}
              required
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">Name</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setName(e.target.value)}
              value={name}
            >
              <option value={null}>Select Name</option>
              <option value={0}>Row 1</option>
              <option value={1}>Row 2</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">Label</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setLabel(e.target.value)}
              value={label}
            >
              <option value={null}>Select Label</option>
              <option value={0}>Row 1</option>
              <option value={1}>Row 2</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Title {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter File Title"
              onChange={(e) => {
                setFileName(e.target.value);
                validatetitle(e.target.value);
              }}
              value={fileName}
              required
            />
            {error && (
              <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                File Title should only contain capital letters, small
                letters, underScore and numbers "Space Not Allowed"
              </span>
            )}
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              File Label {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter File Label"
              onChange={(e) => setFileLabel(e.target.value)}
              value={fileLabel}
              required
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={uploadFileinEDCLupDataLibrary}
            disabled={buttonLoader || !format || !uploadFile || !fileName || !fileLabel || !type || error}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Uploading...
              </div>
            ) : (
              "Upload"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UploadFileDataLibrary;
